import React, { useState, useEffect, useRef } from 'react';
import { ZONES_ENDPOINT } from '../../../config/urls';
import { useAuth } from "../../../hooks/AuthProvider";
import TableAutocomplete from '../../../common/table-autocomplete';

const URL = ZONES_ENDPOINT;

const SearchInput = ({ updateSearchValue }) => {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getValidToken } = useAuth();
  const latestQuery = useRef('');
  const getHeaders = async () => ({
    Authorization: `Bearer ${await getValidToken()}`,
    'Content-Type': 'application/json',
    'X-Tenant-Id': localStorage.getItem('tenant'),
  });

  const handleInputChange = (event, value, reason) => {
    setQuery(value);
    // 'reset' fires when an option is picked; the text is the option label, not a new search.
    if (reason === 'reset') return;
    if (value === '') {
      updateSearchValue('');
    } else {
      fetchSearchResults(value);
    }
  };

  const handleOptionSelect = (event, value) => {
    if (value && value.id) {
      updateSearchValue(value.id);
    }
  };

  const fetchSearchResults = async (searchQuery) => {
    latestQuery.current = searchQuery;
    setLoading(true);
    try {
      // Only zones that have customers, matched by name on the server.
      const response = await fetch(
        `${URL}?search_value=${encodeURIComponent(searchQuery)}&has_customers=true`,
        { headers: await getHeaders() }
      );
      const data = await response.json();
      // Drop responses for older keystrokes that arrive after newer ones.
      if (latestQuery.current === searchQuery) setOptions(data.results || []);
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) setOptions([]);
  }, [open]);

  return (
    <TableAutocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      inputValue={query}
      onInputChange={handleInputChange}
      onChange={handleOptionSelect}
      options={options}
      loading={loading}
      getOptionLabel={(option) => `${option.name}`}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      tooltip="Search zone name"
      placeholder="Search zone name"
      sx={{ width: { xs: '100%', sm: 340 } }}
      renderOption={(props, option) => (
        <li {...props}>
          <strong>{option.name}</strong>
        </li>
      )}
    />
  );
};

export default SearchInput;